import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stripe-ach-instant-verification-info-dialog',
  templateUrl: './stripe-ach-instant-verification-info-dialog.component.html',
  styleUrls: ['../../shared/styles/layout.scss']
})
export class StripeAchInstantVerificationInfoDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
